import React, { useCallback, useEffect, useState } from "react";
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import PagesFiltersToolsBar from "../components/PagesFiltersToolsBar";
import Swal from "sweetalert2";
import PaginationComponent from "../components/Pagination";
import EmptyListWarning from "../components/EmptyListWarning/EmptyListWarning";
import UserListCard from "../components/UserListCard";
import { useAPI } from "app/hooks/useApi";
import HeaderPages from "../components/HeaderPages";

const Usuarios = () => {
  const [count, setCount] = useState(100);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [searchTerm, setSearchTerm] = useState("");
  const [usuarios, setUsuarios] = useState([]);

  const { makeRequest } = useAPI();

  const getUsuarios = useCallback(async () => {
    let url = `/users?page=${page}&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`;

    if (searchTerm) {
      url += `&searchTerm=${searchTerm}`
    }

    const response = await makeRequest(url, "GET");

    if (response.status === 200) {
      setUsuarios(response.data.users);
      setCount(response.data.count);
    }
  }, [page, perPage, sortBy, sortOrder, searchTerm]);

  const deleteUsuario = useCallback(
    async (idUsuario) => {
      const result = await Swal.fire({
        title: "Tem certeza?",
        text: "Essa ação não pode ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        const response = await makeRequest(`/users/${idUsuario}`, "DELETE");

        if (response.status === 200) {
          Swal.fire(
            "Excluído!",
            "O usuário foi removido com sucesso.",
            "success"
          );
          getUsuarios();
        } else {
          Swal.fire("Erro!", "Não foi possível excluir o usuário.", "error");
        }
      }
    },
    [getUsuarios]
  );

  const handleSearch = useCallback(() => {
    getUsuarios();
  }, [searchTerm, getUsuarios]);

  useEffect(() => {
    getUsuarios();
  }, [getUsuarios]);

  return (
    <JumboContentLayout
      header={
        <HeaderPages
          title={"Usuários"}
          buttonHref={"/usuario"}
          buttonTitle={"Criar usuário"}
          hasButton={true}
        />
      }
    >
      <PagesFiltersToolsBar
        value={searchTerm}
        setValue={setSearchTerm}
        onSearch={handleSearch}
      />

      {usuarios && usuarios.length > 0 ? (
        usuarios.map((usuario) => <UserListCard user={usuario} deleteUser={deleteUsuario}  />)
      ) : (
        <EmptyListWarning />
      )}

      <PaginationComponent
        count={count}
        page={page}
        perPage={perPage}
        sortBy={sortBy}
        sortOrder={sortOrder}
        setPage={setPage}
        setPerPage={setPerPage}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
      />
    </JumboContentLayout>
  );
};

export default React.memo(Usuarios);
